module.exports = __webpack_public_path__ + "static/media/kendricklamar-goodkidmaadcity.c9750728.jpg";